export default "__VITE_ASSET__ofp5tVaA__"